import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import api from "../utils/api";
import SEOHead from "../CommanComponents/SEOHead";

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async (values, { resetForm }) => {
    setLoading(true);
    try {
      console.log(api, "göderilen değir");
      const res = await api.post("login", values);

      if (res.status === 200) {
        const { token, refreshToken, user } = res.data;
        localStorage.setItem("token", token);
        if (refreshToken) {
          localStorage.setItem("refreshToken", refreshToken);
        }
        localStorage.setItem("postUser", JSON.stringify(user));
        navigate("/protected");
        resetForm();
      }
    } catch (error) {
      console.error("Giriş hatası:", error);
      alert("Giriş yapılamadı!");
    } finally {
      setLoading(false);
    }
  };
  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: {
      email: "",
      password: "",
      verify: false,
    },
    onSubmit: submit,
  });

  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center 
    bg-yellow-100 relative overflow-hidden"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      <SEOHead
        title="Giriş Yap"
        description="Classroom platformuna giriş yapın, öğrencinizin İngilizce eğitim ilerlemesini takip edin ve derslere devam edin."
      />
      {/* Fun Background Elements */}
      <BackGroundColor />
      {/* Content */}
      <div className="z-10 bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <div className="flex-shrink-0">
            <img src="icons.png" alt="icon" className="w-32 h-32 rounded-2xl" />
          </div>
        </div>

        <div className="w-full">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col justify-center items-center p-4 gap-6">
              <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="email"
                  className="block text-lg font-bold text-orange-500"
                >
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2 border-purple-300 focus:border-purple-500"
                  placeholder="eposta-adresiniz@ornek.com"
                />
              </div>

              <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="password"
                  className="block text-lg font-bold text-orange-500"
                >
                  Şifre
                </label>
                <input
                  type="password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2 border-purple-300 focus:border-purple-500"
                  placeholder="••••••••"
                />
              </div>
              <div className="flex justify-end ml-50">
                <button
                  type="button"
                  onClick={() => navigate("/forgat_password")} // Fixed the typo here
                  className="text-blue-500 hover:text-blue-700"
                >
                  {/* <span> Forget Password</span>
                  <hr className="border-1 border-yellow-400" /> */}
                  <span className="text-sm text-blue-500 font-normal text-center">
                    Şifremi Unuttum
                  </span>
                </button>
              </div>
              <div className="w-full mt-4">
                <button
                  className="bg-green-500 hover:bg-green-600 text-white text-xl 
                  font-bold rounded-full w-full h-14 transition-colors duration-300 flex flex-col
                   items-center justify-center"
                  type="submit"
                >
                  Öğrenmeye başla
                </button>
              </div>

              <div className="mt-4 text-center flex items-center justify-center gap-2 w-full">
                <div className="flex flex-col">
                  {/* <hr className="border-0.5 border-yellow-400 w-48" /> */}
                  <span className="text-sm text-blue-500 font-normal text-center">
                    Eğer bir hesabınız yoksa?
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => navigate("/register")}
                  className="text-purple-500 hover:text-purple-800"
                >
                  <span className="text-sm font-normal underline  underline-offset-2 ">
                    kayıt ol
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
